import { createContext, useContext } from 'react';
var MenuListContext = /*#__PURE__*/createContext(null);
export var MenuListStateProvider = MenuListContext.Provider;
export var useMenuListState = function useMenuListState() {
  var context = useContext(MenuListContext);

  if (!context) {
    throw new Error("MenuListContext isn't available. Please set it via MenuListContextProvider component.");
  }

  return context;
};